import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { VENDOR_LIST, VENDOR_SERVICE_DETAIL } from "./type";

export const getVendorList = (siteId, prType = null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.vendorList}?site_id=${siteId}${prType ? `&pr_type=${prType}` : ''}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VENDOR_LIST, payload: data.response.data });
    return true;
  }
};

export const allocateVendor = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    `${Config.installation.vendorAllocate}?site_id=${requestData.siteId}&vendor_id=${requestData.vendorId}`
  );
  if (res?.data?.status === true) {
    return true;
  }
};

export const getVendorServiceDetail = (vendorCode,siteId=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.vendorServiceDetail}?vendor_code=${vendorCode}&site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VENDOR_SERVICE_DETAIL, payload: data.response.data });
    return true;
  }
};

export const postVendorService = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    `${Config.installation.postVendorService}`
  );
  if (res?.data?.status === true) {
    return true;
  }else{
    return false;
  }
};

export const updateVendorAllocation = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    `${Config.installation.updateVendorAllocation}`
  );
  const apiStatus = res?.data?.status;
  const apiMessage = (res?.data?.message || "").toString().toLowerCase();
  const apiData = (res?.data?.data || "").toString().toLowerCase();
  const isSuccess =
    apiStatus === true ||
    apiStatus === 0 ||
    apiMessage === "success" ||
    apiData.includes("updated successfully");

  if (isSuccess) {
    return true;
  } else {
    return false;
  }
};